/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type SentAccessRequestsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ServiceAdminOrgAccessRequestFilter>;
}>;


export type SentAccessRequestsQuery = { __typename: 'Query', myAccessRequests: Array<{ __typename: 'ServiceAdminOrgAccessRequestDocument', id: string, targetOrganizationId: string, targetOrganizationName?: string | null, targetOrganizationDisplayCount?: number | null, targetOrganizationOwnerEmail?: string | null, status: Types.ServiceAdminOrgAccessRequestStatus, createdAt: any, accessExpiresAt?: any | null }> };


export const SentAccessRequestsDocument = gql`
    query SentAccessRequests($filter: ServiceAdminOrgAccessRequestFilter) {
  myAccessRequests(filter: $filter) {
    id
    targetOrganizationId
    targetOrganizationName
    targetOrganizationDisplayCount
    targetOrganizationOwnerEmail
    status
    createdAt
    accessExpiresAt
  }
}
    `;

/**
 * __useSentAccessRequestsQuery__
 *
 * To run a query within a React component, call `useSentAccessRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentAccessRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentAccessRequestsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSentAccessRequestsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SentAccessRequestsQuery, SentAccessRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SentAccessRequestsQuery, SentAccessRequestsQueryVariables>(SentAccessRequestsDocument, options);
      }
export function useSentAccessRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SentAccessRequestsQuery, SentAccessRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SentAccessRequestsQuery, SentAccessRequestsQueryVariables>(SentAccessRequestsDocument, options);
        }
export type SentAccessRequestsQueryHookResult = ReturnType<typeof useSentAccessRequestsQuery>;
export type SentAccessRequestsLazyQueryHookResult = ReturnType<typeof useSentAccessRequestsLazyQuery>;
export type SentAccessRequestsQueryResult = ApolloReactCommon.QueryResult<SentAccessRequestsQuery, SentAccessRequestsQueryVariables>;